import {PublishingRecordForButton} from 'notebook/template-publishing/graphql/types';
import {TemplatePublishingButtonProps} from 'notebook/template-publishing/TemplatePublishingButton';
import {PublishableVersionStatus} from 'notebook/template-publishing/TemplatePublishingConstants';

type PublishingButtonInfo = Pick<
  TemplatePublishingButtonProps,
  'versionName' | 'versionModifiedAt' | 'status'
>;

export function getPublishableInfoForPublishingButton(
  publishingRecords: Array<PublishingRecordForButton>,
  versionApiId: string,
  versionModifiedAt: string,
  isCurrentVersion: boolean
): PublishingButtonInfo {
  const baseResult = {
    versionModifiedAt,
  };
  // Try to find a publishing record for the specified version. This indicates that the version was published
  const publishingRecord = publishingRecords.find((pr) => pr.publishableVersionId === versionApiId);
  if (publishingRecord) {
    return {
      ...baseResult,
      versionName: publishingRecord.versionName,
      status:
        PublishableVersionStatus[publishingRecord.publishingStatus as keyof typeof PublishableVersionStatus],
    };
  }

  return {
    ...baseResult,
    status: isCurrentVersion ? PublishableVersionStatus.DRAFT : PublishableVersionStatus.DRAFT_NON_CURRENT,
  };
}
